import React, { useState, useEffect } from 'react';
import { Box, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Link, CircularProgress, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { fetchAgeGroups, AgeGroup } from '../api/contests';

const QuickLink = (url: string) => (name: string) => (
    <Link href={url} target="_blank" rel="noopener noreferrer">{name}</Link>
);
const channelLink = QuickLink("https://SeregaPhotoskiff.t.me");
const chatLink = QuickLink("https://SeregaPhotoskiffChat.t.me");
const botLink = QuickLink("https://t.me/photoskiff_zarubaweb_bot");

const uploads = "https://photoskiff.com/zaruba/dbapi/uploads/";
const botButtons = uploads + "bot-buttons.jpg";
const botChatLink = uploads + "bot-chat-link.png";
const botMenu = uploads + "bot-menu.png";
const botProfileForm = uploads + "bot-profile-form.jpg";
const botSubmissionForm = uploads + "bot-submission-form.jpg";

const AboutPage: React.FC = () => {
    const [ageGroups, setAgeGroups] = useState<AgeGroup[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const loadAgeGroups = async () => {
            try {
                const data = await fetchAgeGroups();
                setAgeGroups(data);
            } catch (error) {
                console.error('Error loading age groups:', error);
            } finally {
                setLoading(false);
            }
        };

        loadAgeGroups();
    }, []);

    return (
        <Box p={3}>
            {/*<Typography variant="h5" gutterBottom color="primary">*/}
            {/*    О Зарубах*/}
            {/*</Typography>*/}

            <Accordion >
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography variant="h6" color={"primary"} >Что такое "Зарубы"</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography variant='body1' paragraph>
                        "Зарубы" — это уникальная разработка, единственная в своём роде: вебсайт, специально написанный мной для подписчиков моего канала {channelLink("PhotoSkiff")}.
                    </Typography>
                    <Typography variant='body1' paragraph>
                        На сайте публикуются соревнования — "зарубы", специально подобранные так, чтобы в них могли принимать участие как начинающие, так и опытные любители спорта.
                    </Typography>
                    <Typography variant='body1' paragraph>
                        Главная цель "заруб" — побуждение людей к активному образу жизни и мотивация к физическому прогрессу. За основу "заруб" взяты упражнения с гирей, которые можно использовать в домашних условиях, в спортзале и на улице. Т
                        акже мы проводим зарубы в упражнениях с собственным весом.
                    </Typography>
                    <Typography variant='body1' paragraph>
                        "Зарубы" — тесно интегрированы с Телеграм. Для членов {chatLink("чата канала")} создан уникальный бот который позволяет посылать заявки о результатах в зарубе, редактировать профиль участника,
                        октрывать зарубы внутри Телеграм. Бот оповещает участников о публикации заявок и о появлении нового лидера в зарубах.
                    </Typography>
                    <Typography>
                        Участвовать в зарбуах могут только подписчики {chatLink("чата канала")}.
                        <p/>
                        "Зарубы" и канал c чатом созданы исключительно для популяризации здорового образа жизни и не преследуют никакой коммерческой цели.
                    </Typography>
                </AccordionDetails>
            </Accordion>

            <Accordion >
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography variant="h6" color={"primary"}>Отличия от традиционных соренований</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <ul>
                        <li>Заруба не река: в неё можно войти сколько угодно раз. У каждой зарубы нет даты окончания — рейтинг постоянно обновляется с новыми результатами.</li>
                        <li>Все результаты и записи сохраняются, что позволяет отслеживать прогресс.</li>
                        <li>Гири любого веса могут использоваться в соревнованиях. при заявке выполнение зарубы с новым весом автоматически
                            создаётся новая категория.</li>
                        <li>При каждой заявке резульата, участники могут оставлять записи о состоянии (пульс, настроение и т.п.) для анализа прогресса.</li>
                        <li>Каждому участнику отводится собственная страница на сайте с историей результатов и с профилем, где участник может рассказать о себе и добавить ссылки на свои социальные сети.</li>
                        <li>Главный фокус заруб не на результате, а на прогрессе участников. Для этого существует рейтинг по прогрессу, астивности и разносторонности участников. 
                            Эти характеристики визуально подкреплены стрелками трендов</li>
                    </ul>
                </AccordionDetails>
            </Accordion>

            <Accordion>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography variant="h6" color={"primary"}>Рекомендации для участников</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <ul>
                        <li>Не готовьтесь специально к первой зарубе, просто зарегистрируйте первый результат без подготовки.</li>
                        <li>Участвуйте в разных зарубах для всестороннего развития.</li>
                        <li>Используйте гири разного веса для тренировки различных качеств (силы, выносливости).</li>
                        <li>Регулярно обновляйте результаты в разных зарубах, используя метод периодизации нагрузок.</li>
                        <li>При заявке резульата, сделайте запись о своём состоянии во время выполнения заруб для анализа прогресса.</li>
                        <li>Не бойтесь выполнить зарубу с нестандартным весом гирь — каждая категория учитывается.</li>
                        <li>Выбирайте возрастную группу по ощущениям, не по биологическому возрасту.</li>
                    </ul>
                </AccordionDetails>
            </Accordion>

            <Accordion>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography variant="h6" color={"primary"}>Правила и традиции канала</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <ul>
                        <li>Среди подписчиков с некоторого времени укрепилось название чата канала: ЧаД</li>
                        <li>В чаДе все равны. В силу того, что каждый волен выбирать возрастную группу по ощущениям. Я
                            предпочитаю, чтобы меня называли "Серёга" и на "ты". В свою очередь, чтобы никому не было
                            обидно
                            я тоже ко всем обращаюсь на "ты"
                        </li>
                        <li>В чаДе хорошей традицией стали дружеский совет, поддержка, доброе отношение</li>
                        <li>На канале неприемлема никакая реклама и самореклама. Аккаунт, пославший рекламу или спам,
                            моментально блокируется и заявляется как рассыльщик спама.
                            Оганиченные полезные ссылки не возбраняются, но я буду удалять их по собственному
                            усмотрению, если посчитаю нужным
                        </li>
                        <li>Нецензурная лексика, грубость, преследование и т.п. влекут за собой блокировку аккаунта</li>
                    </ul>
                </AccordionDetails>
            </Accordion>

            <Accordion>
                <AccordionSummary expandIcon={<ExpandMoreIcon/>}>
                    <Typography variant="h6" color={"primary"}>Возрастные группы</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography variant="body1" paragraph>
                        Деление на возрастные группы условно, и участник волен выбрать любую по предпочтению.
                    </Typography>
                    {loading ? (
                        <Box display="flex" justifyContent="center" mt={2}>
                            <CircularProgress/>
                        </Box>
                    ) : (
                        <TableContainer component={Paper}>
                            <Table>
                            <TableHead>
                                    <TableRow>
                                        <TableCell><b>Группа</b></TableCell>
                                        <TableCell><b>Мин. возраст</b></TableCell>
                                        <TableCell><b>Макс. возраст</b></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {ageGroups.map((group) => (
                                        <TableRow key={group.age_group_id}>
                                            <TableCell>{group.age_group_name}</TableCell>
                                            <TableCell>{group.min_age}</TableCell>
                                            <TableCell>{group.max_age}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    )}
                </AccordionDetails>
            </Accordion>
            <Accordion>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography variant="h6" color={"primary"}>Заруба Бот</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography variant='body1' paragraph>
                        "Зарубы" — тесно интегрированы с Телеграм. Для членов {chatLink("чата канала")} создан уникальный бот, который позволяет посылать заявки о результатах в зарубе, редактировать профиль участника и открывать зарубы внутри Телеграм. Бот оповещает участников о публикации заявок и о появлении нового лидера в зарубах.
                    </Typography>

                    <Typography variant='body1' paragraph>
                        Работа с ботом возможна только в чате самого бота. В телеграм-чате в правом нижнем углу есть кнопка команд бота. Нажав её, вы увидите меню из трёх команд. При нажатии любой из команд бот даст вам ссылку, по которой можно перейти в чат самого бота.
                    </Typography>

                    <Box my={3} display="flex" justifyContent="center">
                        <img
                            src={botChatLink}
                            alt="Bot chat link"
                            style={{
                                width: '100%',
                                maxWidth: '400px',
                                border: '1px solid #ddd',
                                borderRadius: '8px',
                                padding: '8px',
                                backgroundColor: '#f9f9f9'
                            }}
                        />
                    </Box>

                    <Typography variant='body1' paragraph>
                        На канале бота, нажав на меню, вы увидите три команды. Верхняя команда предоставит ссылки на вебсайт "Заруб". Нажатие на ссылку откроет зарубы в вашем браузере, а нажатие на кнопку загрузит "Зарубы" прямо в Телеграм.
                    </Typography>

                    <Box my={3} display="flex" justifyContent="center">
                        <img
                            src={botMenu}
                            alt="Bot menu"
                            style={{
                                width: '100%',
                                maxWidth: '300px',
                                border: '1px solid #ddd',
                                borderRadius: '8px',
                                padding: '8px',
                                backgroundColor: '#f9f9f9'
                            }}
                        />
                    </Box>

                    <Typography variant='body1' paragraph>
                        Нажав команду "заявить свой результат в зарубе", вы увидите кнопку, после нажатия которой откроется форма для заявки результата.
                    </Typography>

                    <Typography variant='body1' paragraph>
                        С помощью команды "Открыть редактор профиля участника" вы сможете отредактировать свой профиль.
                    </Typography>

                    <Box my={3} display="flex" justifyContent="center">
                        <img
                            src={botButtons}
                            alt="Bot buttons"
                            style={{
                                width: '100%',
                                maxWidth: '300px',
                                border: '1px solid #ddd',
                                borderRadius: '8px',
                                padding: '8px',
                                backgroundColor: '#f9f9f9'
                            }}
                        />
                    </Box>

                    <Typography variant='body1' paragraph>
                        Здесь показаны формы заявки результата и редакции профиля. В обоих случаях, заполнив форму, нужно нажать кнопку внизу для завершения редактирования и отправки формы. Если заявка результата была успешно отправлена модератору, бот оповестит вас об этом. Когда ваш результат будет опубликован, бот сообщит об этом вам и пошлёт сообщение в чат.
                    </Typography>

                    <Box my={3} display="flex" justifyContent="center" flexDirection={{ xs: 'column', sm: 'row' }} gap={2}>
                        <img
                            src={botSubmissionForm}
                            alt="Bot submission form"
                            style={{
                                width: '100%',
                                maxWidth: '300px',
                                border: '1px solid #ddd',
                                borderRadius: '8px',
                                padding: '8px',
                                backgroundColor: '#f9f9f9',
                                marginBottom: '16px'
                            }}
                        />
                        <img
                            src={botProfileForm}
                            alt="Bot profile form"
                            style={{
                                width: '100%',
                                maxWidth: '300px',
                                border: '1px solid #ddd',
                                borderRadius: '8px',
                                padding: '8px',
                                backgroundColor: '#f9f9f9',
                                marginBottom: '16px'
                            }}
                        />
                    </Box>
                </AccordionDetails>
            </Accordion>
            <Accordion>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography variant="h6" color={"primary"}>Дисклеймер</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <ul>
                        <li>Принимая решение участвовать в Зарубах, участник подтверждает, что он полностью здоров, 
                            осведомлен о потенциальных рисках, связанных с физическими нагрузками, 
                            и берет на себя всю ответственность за свое здоровье и безопасность. </li>
                        <li>Участник должен адекватно оценивать свою физическую подготовку и состояние здоровья и выбирать 
                        соответствующий уровень Зарубы, в которой он собрался участвовать</li>
                        <li>Канал не предоставляет медицинских консультаций и не несет ответственности за любые травмы, 
                            или иные последствия, возникшие в результате участия в Зарубах.
                        </li>
                        <li>
                            При травмоопасной технике выполнения упражнения судья может не засчитать результат даже если формально 
                            упражнение выполнено
                        </li>
                    </ul>
                </AccordionDetails>
            </Accordion>
        </Box>
    );
};

export default AboutPage;
